import React from 'react';
import './ContactBarTwo.css';
import NavLogo from './../../assets/images/tester3.webp';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Link } from 'react-router-dom';

const ContactBarTwo = () => {
  return (
    <div className="contactbar">
      <div className="col-wrapper">



        {/* Center: Logo */}
        <div className="col-item navLogo center-logo">
          <div className="image-wrapper">
            <Link to="/">
              <img
                src={NavLogo}
                alt="Watkins Seamless Gutters Logo"
                width={473}
                height={238}
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactBarTwo;
